<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbti_lloopon_sel" class="mt-1">Left AO loop</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lloopon" class="w-100"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbti_rloopon_sel" class="mt-1">Right AO loop</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_rloopon" class="w-100"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbti_lmir_fw1_sel" class="mt-1">Filter #1</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lmir_fw1" class="w-100"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbti_lmir_fw2_sel" class="mt-1">Filter #2</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lmir_fw2" class="w-100"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbti_lmir_fw3_sel" class="mt-1">Filter #3</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lmir_fw3" class="w-100"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbti_lmir_fw4_sel" class="mt-1">Filter #4</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lmir_fw4" class="w-100"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbti_lm_apwhl_sel" class="mt-1">Aperture</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lm_apwhl" class="w-100"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbti_lm_fw25_sel" class="mt-1">Filter #2.5</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lm_fw25" class="w-100"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbti_ncoadds_sel" class="mt-1">Coadds</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_ncoadds" class="w-100"></b-form-input>
    </div>
    <div class="col-3 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbti_pcclosed_sel" class="mt-1">Phase loop closed flag</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_pcclosed" class="w-100"></b-form-input>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3 offset-3 text-center">
      <strong>Min</strong>
    </div>
    <div class="col-3 text-center">
      <strong>Max</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_lbt_airm_sel" class="mt-1">Air Mass</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_airm_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_airm_min">{{fieldErrors.lbti_lbt_airm_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_airm_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_airm_max">{{fieldErrors.lbti_lbt_airm_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_lbt_alt_sel" class="mt-1">Elevation (deg)</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_alt_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_alt_min">{{fieldErrors.lbti_lbt_alt_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_alt_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_alt_max">{{fieldErrors.lbti_lbt_alt_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_lbt_az_sel" class="mt-1">Azimuth (deg)</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_az_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_az_min">{{fieldErrors.lbti_lbt_az_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_az_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_az_max">{{fieldErrors.lbti_lbt_az_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_lbt_para_sel" class="mt-1">Parallactic angle (deg)</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_para_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_para_min">{{fieldErrors.lbti_lbt_para_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_para_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_para_max">{{fieldErrors.lbti_lbt_para_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_lbt_utc_sel" class="mt-1">UTC (hours)</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_utc_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_utc_min">{{fieldErrors.lbti_lbt_utc_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_lbt_utc_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_lbt_utc_max">{{fieldErrors.lbti_lbt_utc_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.lbti_exptime_sel" class="mt-1">Exposure Time (ms)</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_exptime_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_exptime_min">{{fieldErrors.lbti_exptime_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbti_exptime_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbti_exptime_max">{{fieldErrors.lbti_exptime_max}}</span>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'Lbti',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  })
}
</script>
